import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { filter } from 'rxjs/operators';
import { formatDateS } from '../../helpers/helper';
import { GratisCondition, GratisConditionValueType, GratisEditor, LabelValue, ProductItem } from '../../interfaces/interfaces';
import { ApiService } from '../../services/api.service';
import { ConfirmComponent } from '../confirm/confirm.component';
import { ProductsearchComponent } from '../productsearch/productsearch.component';

@Component({
  selector: 'lib-productsgratiseditor',
  templateUrl: './productsgratiseditor.component.html',
  styleUrls: ['./productsgratiseditor.component.scss']
})
export class ProductsgratiseditorComponent implements OnInit {

  gratisEditor: GratisEditor = {
    conditions: [],
    dateFrom: null,
    dateTo: null,
    gift: '',
    giftProducts: [],
    minFulfilledCount: 0,
    name: ''
  };

  gratisId: number = null;

  valueTypes: LabelValue[] = [
    { label: 'Egység', value: 'UNIT' },
    { label: 'Karton', value: 'CARTON' },
    { label: 'Nettó össz ár', value: 'NET_PRICE' },
    { label: 'Bruttó össz ár', value: 'GROSS_PRICE' }
  ];

  constructor(
    private las: ApiService,
    private dialogService: DialogService,
    private router: Router,
    private activatedRoute: ActivatedRoute
  ) {
    const gratisId: string = this.activatedRoute.snapshot.paramMap.get('id');
    if (gratisId !== null) {
      this.gratisId = parseInt(gratisId, 10);
    }
  }

  ngOnInit(): void {
    this.getGratis();
  }

  getGratis(): void {
    if (this.gratisId !== null) {
      this.las.getProductsGratis(this.gratisId).subscribe(({gratisEditor}) => {
        gratisEditor.dateFrom = formatDateS(gratisEditor.dateFrom);
        gratisEditor.dateTo = formatDateS(gratisEditor.dateTo);
        if (gratisEditor.giftProducts === undefined) {
          gratisEditor.giftProducts = [];
        }
        this.gratisEditor = gratisEditor;
      });
    }
  }

  addGift(): void {
    this.dialogService.open(ProductsearchComponent, {}).onClose.pipe(filter(result => result !== undefined)).subscribe((productItem: ProductItem) => {
      this.gratisEditor.giftProducts.push({
        productId: productItem.id,
        productName: productItem.name + '(' + productItem.pcode + ')',
        quantity: 1
      })
    });
  }

  deleteGift(index: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Ajándék törlése',
        text: 'Biztosan törölni ezt az ajándékot?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.gratisEditor.giftProducts.splice(index, 1);
    });
  }

  addCondition(): void {
    this.gratisEditor.conditions.push({
      products: [],
      sumValue: 0,
      valueType: GratisConditionValueType.UNIT
    });
  }

  removeCondition(index: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Feltétel törlése',
        text: 'Biztosan törölni szeretnéd ezt a feltételt?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      this.gratisEditor.conditions.splice(index, 1);
    });
  }

  removeProduct(condition: GratisCondition, index: number): void {
    this.dialogService.open(ConfirmComponent, {
      data: {
        title: 'Termék törlése',
        text: 'Biztosan törölni szeretnéd ezt a terméket?',
        acceptText: 'Törlés',
        declineText: 'Mégse'
      }
    }).onClose.pipe(filter(r => r === true)).subscribe(() => {
      condition.products.splice(index, 1);
    });
  }

  showProductSearchModal(condition: GratisCondition): void {
    this.dialogService.open(ProductsearchComponent, {}).onClose.pipe(filter((result: any) => result !== null && result !== undefined)).subscribe((productItem: ProductItem) => {
      condition.products.push({
        id: productItem.id,
        name: productItem.name
      });
    });
  }

  save(): void {
    if (this.gratisId === null) {
      this.las.createProductsGratis(this.gratisEditor).subscribe(() => {
        this.router.navigate(['/productsgratis']);
      })
    } else {
      this.las.updateProductsGratis(this.gratisId, this.gratisEditor).subscribe(() => {
        this.router.navigate(['/productsgratis']);
      });
    }
  }

}
